var $ = require('jquery');

var Map = function Map() {
	var mapEl = $('.map')[0];
	if(mapEl) {
		var styles = [{"featureType":"all","elementType":"all","stylers":[{"hue":"#0e0f12"},{"saturation":-91}]}];

		var gmap = new google.maps.Map(mapEl, {
			mapTypeControlOptions: {
				mapTypeIds: ['Styled']
			},
			center: {lat: 52.636468, lng: -1.144572},
			zoom: 17,
			scrollwheel: false,
			mapTypeId: 'Styled'
		});

		var styledMapType = new google.maps.StyledMapType(styles, {name: 'Styled'});
		gmap.mapTypes.set('Styled', styledMapType);

		var gmark = new google.maps.Marker({
			position: {
				lat: 52.636468,
				lng: -1.144572
			},
			map: gmap
		});
	}
}

module.exports = Map;